import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import ScrollToTopButton from '../components/ScrollToTopButton';
import LoadingSpinner from '../components/LoadingSpinner';
import "../components/CSS/Pages/AboutUsPage.css";
import bg from '../assets/images/whoWeArePage-hero-img.jpg';
import AboutUsContent from '../components/AboutusPage/AboutUsContent';

const HeroSection = lazy(() => import('../components/HeroSection-new'));
const FooterSection = lazy(() => import('../components/FooterNew'));
const MobileButton = lazy(() => import('../components/MobileBookNowButton'));

const AboutUsPage = () => {
    const title = 'Who We Are';
    const sub = 'Crafting Tranquil Journeys with Expertise and Care';
    const aboutImg = ''

    return (
        <>
            <Helmet>
                <meta name="description" content="A Forbes Coach Council member and a leading practitioner of the original form of mindfulness. With over 12 years of experience in the travel industry in the USA, Dr. Hewawasam has recognized a gap between traditional mindfulness teachings preserved in Sri Lanka and their often diluted Western practices." />
                <link rel="canonical" href="https://inttleisure.com/why-choose-us" />
            </Helmet>
            <Suspense fallback={<LoadingSpinner />}>
                <HeroSection img={bg} title={title} sub={sub} aboutImg={aboutImg} />
            </Suspense>
            <AboutUsContent />
            <Suspense fallback={<LoadingSpinner />}>
                <FooterSection />
            </Suspense>
            <Suspense fallback={<LoadingSpinner />}>
                <MobileButton label="Book Now" />
            </Suspense>
            <ScrollToTopButton />
        </>
    )
}

export default AboutUsPage;